import { render } from "./IconFaibleGluten.vue?vue&type=template&id=48c93d62"
import script from "./IconFaibleGluten.vue?vue&type=script&lang=js"
export * from "./IconFaibleGluten.vue?vue&type=script&lang=js"

import exportComponent from "D:\\perso\\miam\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__